import { FileShareUpload, FileShareHeader, FileShareTabs } from 'features/fileshare/components'
import styled from 'styled-components'

export const FileShare = () => {
  return (
    <Div>
      <FileShareHeader />
      <div className="sidebar-container">
        <FileShareUpload />
      </div>
      <FileShareTabs />
    </Div>
  )
}

const Div = styled.div`
  .sidebar-container {
    float: left;
  }
`
